import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useEffect, useState } from 'react';

export interface Country {
    id: number;
    name: string;
    iso2: string;
    iso3?: string;
    phoneCode?: string;
}

export const useCountries = () => {
    const [countries, setCountries] = useState<Country[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const loadCountries = async () => {
        try {
            setLoading(true);
            setError(null);
            const httpClient = createHttpClient(apiClientWH);
            const raw = await httpClient.get<any>('/countries');
            const list = Array.isArray(raw) ? raw : (raw.data ?? []);

            const data = list.map((c: any) => ({
                id: c.id,
                name: c.name,
                iso2: c.iso2,
                iso3: c.iso3,
                phoneCode: c.phoneCode || c.phone_code || c.dial_code || '',
            }));

            // Si no hay datos de la API, usar datos de prueba
            if (data.length === 0) {
                const mockCountries: Country[] = [
                    { id: 1, name: 'España', iso2: 'ES' },
                    { id: 2, name: 'México', iso2: 'MX' },
                    { id: 3, name: 'Argentina', iso2: 'AR' },
                    { id: 4, name: 'Colombia', iso2: 'CO' },
                    { id: 5, name: 'Chile', iso2: 'CL' },
                    { id: 6, name: 'Perú', iso2: 'PE' },
                    { id: 7, name: 'Venezuela', iso2: 'VE' },
                    { id: 8, name: 'Estados Unidos', iso2: 'US' },
                ];
                setCountries(mockCountries);
            } else {
                setCountries(data);
            }
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Error al cargar países');
            console.error('Error loading countries:', err);

            // En caso de error, usar datos de prueba
            const mockCountries: Country[] = [
                { id: 1, name: 'España', iso2: 'ES' },
                { id: 2, name: 'México', iso2: 'MX' },
                { id: 3, name: 'Argentina', iso2: 'AR' },
                { id: 4, name: 'Colombia', iso2: 'CO' },
                { id: 5, name: 'Chile', iso2: 'CL' },
                { id: 6, name: 'Perú', iso2: 'PE' },
                { id: 7, name: 'Venezuela', iso2: 'VE' },
                { id: 8, name: 'Estados Unidos', iso2: 'US' },
            ];
            setCountries(mockCountries);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadCountries();
    }, []);

    return {
        countries,
        loading,
        error,
        loadCountries,
    };
};

